import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ProjectRoleMatrixComponent } from './project-role-matrix.component';
import { UserAvatarModule } from '../user-avatar/user-avatar.module';
import { RoleToggleFilterModule } from '../role-toggle-filter/role-toggle-filter.module';

@NgModule({
  declarations: [ProjectRoleMatrixComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatButtonToggleModule,
    MatTooltipModule,
    UserAvatarModule,
    RoleToggleFilterModule,
  ],
  exports: [ProjectRoleMatrixComponent, RoleToggleFilterModule],
})
export class MatrixModule {}
